/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export class MessageTranslationController {
        public static $name: string = "messageTranslationController";
        public static $inject: string[] = [
            'ModalService',
            '$scope',
            '$timeout',
            'healthService',
            '$filter',
            'timezoneService',
            'userService',
            'messageTranslationsService',
        ];

        private allMessages: Models.MessageTranslation[];
        private loggedUser: Models.User;

        /**
         * Constructor of the class.
         */
        constructor( private modalService: ngModal.IModalService,
                     private $scope: ng.IScope,
                     private $timeout: ng.ITimeoutService,
                     private healthService: Services.HealthService,
                     private $filter: ng.IFilterService,
                     private timezoneService: Services.TimezoneService,
                     private userService: Services.UserService,
                     private messageTranslationsService: Services.MessageTranslationsService) {

            this.initData();
        }

        public launchMessageTranslationModal( title: String, message: Models.IMessageTranslation ): void {
            let element: Models.IMessageTranslation =  Common.Utils.clone(message) as Models.IMessageTranslation;
            this.modalService.showModal({
                templateUrl: Application.Controllers.MessageTranslationModalController.templateUrl,
                controller: Application.Controllers.MessageTranslationModalController.$name,
                inputs: {
                    element: element,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.MessageTranslationModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Models.IMessageTranslation) => {
                    if (result !== undefined) {
                        result.lastUserUpdated = this.loggedUser.username;
                        this.updateMessage( result ).then((response: Models.IMessageTranslation) => {
                            message.description = response.description;
                            message.lastUserUpdated = response.lastUserUpdated;
                            message.updated = response.updated;
                        });
                    }
                    modalElem.hide();
                });
            });
        }

        public updateMessage( message: Models.IMessageTranslation ): ng.IPromise<Models.IMessageTranslation> {
            return this.messageTranslationsService.updateMessage(message);
        }

        private initData(): void {
            this.userService.loadCurrentUser().then((user: Models.User) => {
                // show PipeViewer access button only for admin user
                this.loggedUser = user;
            });

            this.messageTranslationsService.getAllMessages().then((messages: Models.IMessageTranslation[]) => {
                this.allMessages = messages;
            });
        }


    }
}
